import React from 'react';
import { CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';

export default ({
  show = false, action, isInline = false, size = 70, isGlobal = false,
}) => {
  const { pendingActions = [] } = useSelector((e) => e);
  let isAction = false;
  if (Array.isArray(action)) {
    isAction = !!pendingActions.find((e) => action.indexOf(e) !== -1);
  } else {
    isAction = pendingActions.indexOf(action) !== -1;
  }

  return ((show || isAction || (isGlobal && !!pendingActions.length)) && (
    <section className={`${isInline ? 'screen-loader-inline' : 'screen-loader'}`}>
      <CircularProgress style={{ width: size, height: size }} className="loader" />
    </section>
  ));
};
